import { FaStar } from "react-icons/fa";
import React from 'react'
import { FormStarWrapper } from './styled.js'
import { useState } from 'react'
import clsx from 'clsx'

function FormStarRating({ numberStar, setNumberStar }) {
    const [moveStar, setmoveStar] = useState(0)
    let propertive = 'Rất tốt'
    if (numberStar === 5) {
        propertive = 'Rất tốt'
    }
    else if (numberStar === 4) {
        propertive = 'Tốt'
    }
    else if (numberStar === 3) {
        propertive = 'Bình thường'
    }
    else if (numberStar === 2) {
        propertive = 'Kém'
    }
    else if (numberStar === 1) {
        propertive = 'Rất kém'
    }
    if (moveStar === 5) {
        propertive = 'Rất tốt'
    }
    else if (moveStar === 4) {
        propertive = 'Tốt'
    }
    else if (moveStar === 3) {
        propertive = 'Bình thường'
    }
    else if (moveStar === 2) {
        propertive = 'Kém'
    }
    else if (moveStar === 1) {
        propertive = 'Rất kém'
    }

    return (
        <FormStarWrapper>

            <div className='FormStarRatting'>
                <ul className='FormStarRatting_list mb-0'>
                    <li className='FormStarRatting_list_item'>
                        <i className={`FormStarRatting_list_item_icon ${numberStar >= 1 ? "text-red-2" : ""} ${moveStar >= 1 ? "text-red-2" : ""}`}
                            onClick={() => setNumberStar(1)}
                            onMouseMove={() => setmoveStar(1)}
                            onMouseOut={() => setmoveStar(0)}
                        ><FaStar className="s-18" /></i>
                    </li>
                    <li className='FormStarRatting_list_item'>
                        <i className={`FormStarRatting_list_item_icon ${numberStar >= 2 ? "text-red-2" : ""} ${moveStar >= 2 ? "text-red-2" : ""}`}
                            onClick={() => setNumberStar(2)}
                            onMouseMove={() => setmoveStar(2)}
                            onMouseOut={() => setmoveStar(0)}
                        ><FaStar className="s-18" /></i>
                    </li>
                    <li className='FormStarRatting_list_item'>
                        <i className={`FormStarRatting_list_item_icon ${numberStar >= 3 ? "text-red-2" : ""} ${moveStar >= 3 ? "text-red-2" : ""}`}
                            onClick={() => setNumberStar(3)}
                            onMouseMove={() => setmoveStar(3)}
                            onMouseOut={() => setmoveStar(0)}
                        ><FaStar className="s-18" /></i>
                    </li>
                    <li className='FormStarRatting_list_item'>
                        <i className={`FormStarRatting_list_item_icon ${numberStar >= 4 ? "text-red-2" : ""} ${moveStar >= 4 ? "text-red-2" : ""}`}
                            onClick={() => setNumberStar(4)}
                            onMouseMove={() => setmoveStar(4)}
                            onMouseOut={() => setmoveStar(0)}
                        ><FaStar className="s-18" /></i>
                    </li>
                    <li className='FormStarRatting_list_item'>
                        <i
                            className={`FormStarRatting_list_item_icon ${numberStar >= 5 ? "text-red-2" : ""} ${moveStar >= 5 ? "text-red-2" : ""}`}
                            onClick={() => setNumberStar(5)}
                            onMouseMove={() => setmoveStar(5)}
                            onMouseOut={() => setmoveStar(0)}
                        ><FaStar className="s-18"
                            /></i>
                    </li>
                </ul>
                <div className='FormStarRatting_list_propertive flex-center'>
                    <p className="mb-0">{propertive}</p>
                </div>
            </div>
        </FormStarWrapper >
    )
}

export default FormStarRating